import './style.styl';

angular
  .module(__filename, [
    'ui.router',
    'smart-table',

    require('goodeggs-purchase-orders-sdk/purchase_order/angular_resource'),

    require('local_modules/filters/dropoff_window').default.name,
    require('local_modules/filters/format_status').default.name,
    require('local_modules/directives/purchase_order_filters').default,
    require('local_modules/services/purchase_order_filter_service').default,
    require('local_modules/services/external_urls').default,
    require('local_modules/services/supplier').default,
  ])

  .config(
    ngInject(($stateProvider) =>
      $stateProvider.state('purchase_orders.supplier_list', {
        url: '/:supplierSlug?confirmByDay&status',
        template: require('./template'),
        controller: require('./controller').default,
        controllerAs: 'ctrl',
      }),
    ),
  );

export default __filename;
